import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

const GroupFilled = (props) => (
  <Svg
    width={32}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#a)" fill="#5FAFFF">
      <Path d="M16 14.04a4.853 4.853 0 1 0 0-9.707 4.853 4.853 0 0 0 0 9.707ZM9.333 26.187a4.853 4.853 0 1 0 0-9.707 4.853 4.853 0 0 0 0 9.707ZM22.667 26.187a4.853 4.853 0 1 0 0-9.707 4.853 4.853 0 0 0 0 9.707Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h32v32H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default GroupFilled
